import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Container, Link } from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';

import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const ExtensionSubMenu = () => {
  const router = useRouter();
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-second-level-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-second-level-selected-menu';
    return '';
  }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component={'nav'} aria-label="Secondary Navigation"
    >
      <Container
        maxWidth="lg"
        sx={{
          p: '0 !important',
          display: 'flex',
          '& .Mui-selected-menu::before': { bottom: -8 },
        }}
      >
        <CustomButton
          href="/tax-extension/"
          text="Extension<br />Forms"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/extension-icon.png"
              alt="Extension Forms"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          // className={getActiveClassName(['/tax-extension'])}
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          className={getSubMenuHoverClassName('btn-extension-supported-forms')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            aria-haspopup="true"
            id="btn-extension-supported-forms"
            onClick={() =>
              toggleSelectedSubMenu('btn-extension-supported-forms')
            }
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName(['/tax-extension'])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 220, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              <li>
                <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/">
                  Form 7004
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/">
                  Form 4868
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/">
                  Form 8868
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/efile-irs-form-8809-online/">
                  Form 8809
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/file-irs-form-15397-online/">
                  Form 15397
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/form-7004-mobile-app/">
                  Form 7004 Mobile App
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/form-4868-mobile-app/">
                  Form 4868 Mobile App
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-extension-instructions')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-extension-instructions"
            onClick={() => toggleSelectedSubMenu('btn-extension-instructions')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Instructions
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 200,
              right: 'auto !important',
              left: 0,
              '&:before': { left: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/tax-extension/form-7004-instructions/">
                  Form 7004 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-7004-bulk-upload/">
                  Form 7004 Bulk Upload
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-4868-instructions/">
                  Form 4868 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-4868-bulk-upload/">
                  Form 4868 Bulk Upload
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-8868-instructions/">
                  Form 8868 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-8809-instructions/">
                  Form 8809 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-15397-instructions/">
                  Form 15397 Instructions
                </Link>
              </li>
            </Box>
          </Box>
        </Box>

        <Box
          className={getSubMenuHoverClassName('btn-extension-due-dates')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-extension-due-dates"
            onClick={() => toggleSelectedSubMenu('btn-extension-due-dates')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Due Dates
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 250, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/tax-extension/form-7004-due-dates/">
                  Form 7004 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/tools/form-7004-due-date-calculator/">
                  Form 7004 Due Date Calculator
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-4868-due-dates/">
                  Form 4868 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-8868-due-dates/">
                  Form 8868 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-8809-due-dates/">
                  Form 8809 Due Dates
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-extension-resources')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-extension-resources"
            onClick={() => toggleSelectedSubMenu('btn-extension-resources')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Resources
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 220,

              '&:before': { left: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/tax-extension/form-7004-for-form-1042/">
                  Form 7004 for 1042
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-7004-for-form-1065/">
                  Form 7004 for 1065
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-7004-for-form-1120/">
                  Form 7004 for 1120
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-7004-form-codes/">
                  Form 7004 Form Codes
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-7004-and-4868-comparison/">
                  Form 7004 Vs Form 4868
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-extension/form-4868-mailing-addresses-and-filing-guide/">
                  Form 4868 Mailing Address
                </Link>
              </li>
            </Box>
          </Box>
        </Box>

        <CustomButton
          href="/pricing/#extension"
          text="Pricing"
          sm="12px"
          md="14px"
        />
      </Container>
    </Box>
  );
};

export default ExtensionSubMenu;
